import { createFileRoute } from "@tanstack/react-router";

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Field, FieldDescription, FieldGroup, FieldLabel } from "@/components/ui/field";
import { Input } from "@/components/ui/input";
import { ScrollArea } from "@/components/ui/scroll-area";

import { useAuth } from "../../auth";
import { useDocumentTitle } from "@/lib/document-title";

export const Route = createFileRoute("/_app/settings/profile")({
  component: ProfilePage,
});

function ProfilePage() {
  useDocumentTitle(["Profile", "Settings"]);
  const auth = useAuth();
  const membership = auth.me?.memberships[0];

  return (
    <ScrollArea className="min-h-0 flex-1">
      <div className="mx-auto w-full max-w-3xl px-6 py-10 sm:px-10 sm:py-12">
        <header className="mb-8 flex flex-col gap-2">
          <p className="meta-strip">Settings</p>
          <h1 className="font-display text-[2rem] font-semibold leading-tight tracking-tight text-foreground sm:text-[2.5rem]">
            Profile
          </h1>
          <p className="text-sm text-muted-foreground">
            Your account, the way the agent sees you.
          </p>
        </header>

        <div className="flex flex-col gap-6">
          <Card>
            <CardHeader>
              <CardTitle>Account</CardTitle>
              <CardDescription>
                Editing arrives in Phase 2 — for now, profile data is read-only.
              </CardDescription>
            </CardHeader>
            <CardContent>
              <FieldGroup>
                <Field>
                  <FieldLabel htmlFor="profile-email">Email</FieldLabel>
                  <Input id="profile-email" value={auth.me?.user.email ?? ""} disabled />
                  <FieldDescription>Used for sign-in. Cannot be changed yet.</FieldDescription>
                </Field>
                <Field>
                  <FieldLabel htmlFor="profile-name">Name</FieldLabel>
                  <Input id="profile-name" value={auth.me?.user.name ?? ""} disabled />
                </Field>
              </FieldGroup>
            </CardContent>
          </Card>

          {membership && (
            <Card>
              <CardHeader>
                <CardTitle>Organization</CardTitle>
                <CardDescription>
                  The org you're signed in to. Switching orgs lands in Phase 2.
                </CardDescription>
              </CardHeader>
              <CardContent>
                <FieldGroup>
                  <Field>
                    <FieldLabel htmlFor="profile-org">Org</FieldLabel>
                    <Input id="profile-org" value={membership.org_name} disabled />
                  </Field>
                  <Field>
                    <FieldLabel htmlFor="profile-role">Role</FieldLabel>
                    <Input id="profile-role" value={membership.role} disabled />
                  </Field>
                </FieldGroup>
              </CardContent>
            </Card>
          )}
        </div>
      </div>
    </ScrollArea>
  );
}
